"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/* eslint-disable camelcase */
var react_1 = __importDefault(require("react"));
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var react_redux_1 = require("react-redux");
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var tabs_1 = __importDefault(require("relements/build/esm/ui/tabs"));
var confirmationDialog_1 = __importDefault(require("relements/build/esm/decorators/confirmationDialog"));
// Actions
var BotActions_1 = require("@src/actions/BotActions");
var actions_1 = require("@src/containers/BusinessManager/store/actions");
var DomainAPI_1 = require("@src/api/DomainAPI");
// Store
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
var store_1 = __importDefault(require("@src/store"));
// Constants
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var const_1 = require("@src/const");
var index_1 = require("@src/api/index");
var utils_1 = require("@src/utils");
var const_2 = require("./TaskBox/TaskBody/const");
var constants_1 = require("./constants");
var TabContainer_1 = __importDefault(require("../../components/TabContainer"));
var constants_2 = require("../../constants");
var utils_2 = require("../../utils");
var maps_1 = require("./maps");
var utils_3 = require("./utils");
var TaskBox_1 = __importDefault(require("./TaskBox"));
var BotBreakMessages_1 = __importDefault(require("./BotBreakMessages"));
var FeedbackMessages_1 = __importDefault(require("./FeedbackMessages"));
require("./ContentManagement.scss");
// Initial State
var initialState = {
    currentTab: constants_1.TABS.TASKBOX,
    isLoaderActive: true,
    allTaskBoxData: {},
    taskBoxData: {},
    languageCode: constants_1.DEFAULTS.LANGUAGE,
    taskBoxEdited: false,
    allLanguages: [],
    botBreakData: {},
    botBreakEdited: false,
    feedbackMessagesData: { bot: {}, agent: {} },
    feedbackMessagesEdited: false,
    allHybridLanguages: [],
    currentHybridLanguage: constants_1.DEFAULTS.LANGUAGE,
    currentChannel: constants_1.DEFAULTS.CHANNEL_ID,
    isTranslateLoading: false,
    currentChannelName: constants_1.DEFAULTS.CHANNEL_NAME,
    dataUpdatedChannels: {},
    gptDataUpdatedChannels: {},
    updatedFeedbackChannels: {},
    dpsvChannels: [],
    gptDpsvChannels: [],
};
// Reducer
var reducer = function (state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    switch (action.type) {
        case constants_1.REDUCER_ACTIONS.SET_CURRENT_TAB:
            return __assign(__assign({}, state), { currentTab: action.data.tab });
        case constants_1.REDUCER_ACTIONS.SET_LOADER_ACTIVE:
            return __assign(__assign({}, state), { isLoaderActive: action.data.isLoaderActive });
        // #region TASKBOX ACTIONS
        case constants_1.REDUCER_ACTIONS.SET_ALL_TASKBOX_DATA:
            return __assign(__assign({}, state), { allTaskBoxData: action.data.allTaskBoxData, taskBoxData: action.data.taskBoxData, allLanguages: action.data.allTaskBoxData.meta[constants_1.META_KEYS.LANGUAGE_LIST], taskBoxEdited: false });
        case constants_1.REDUCER_ACTIONS.SET_TASKBOX_DATA:
            return __assign(__assign({}, state), { taskBoxEdited: true, taskBoxData: action.data.updatedTaskData });
        case constants_1.REDUCER_ACTIONS.SET_TASK_BOX_EDITED:
            return __assign(__assign({}, state), { taskBoxEdited: action.data.taskBoxEdited });
        case constants_1.REDUCER_ACTIONS.SET_LANGUAGE_CODE:
            return __assign(__assign({}, state), { languageCode: action.data.languageCode, dpsvChannels: ((_a = state.dataUpdatedChannels) === null || _a === void 0 ? void 0 : _a[action.data.languageCode + "|" + state.currentHybridLanguage]) || [], gptDpsvChannels: ((_b = state.gptDataUpdatedChannels) === null || _b === void 0 ? void 0 : _b[action.data.languageCode + "|" + state.currentHybridLanguage]) || [] });
        case constants_1.REDUCER_ACTIONS.ADD_NEW_TASK:
            return __assign(__assign({}, state), { taskBoxEdited: true, taskBoxData: action.data.updatedTaskData });
        case constants_1.REDUCER_ACTIONS.SORT_TASK_LIST:
            return __assign(__assign({}, state), { taskBoxEdited: true, taskBoxData: action.data.updatedTaskData });
        // #endregion
        // #region  BOT BREAK TEMPLATES
        case constants_1.REDUCER_ACTIONS.SET_ALL_BOTBREAK_DATA:
            return __assign(__assign({}, state), { botBreakData: action.data.updatedBotBreakData.body, dpsvChannels: Object.keys(((_e = (_d = (_c = action.data.updatedBotBreakData.body) === null || _c === void 0 ? void 0 : _c.botbreak_templates) === null || _d === void 0 ? void 0 : _d[state.languageCode]) === null || _e === void 0 ? void 0 : _e[state.currentHybridLanguage]) || {}), gptDpsvChannels: Object.keys(((_h = (_g = (_f = action.data.updatedBotBreakData.body) === null || _f === void 0 ? void 0 : _f.gpt_botbreak_templates) === null || _g === void 0 ? void 0 : _g[state.languageCode]) === null || _h === void 0 ? void 0 : _h[state.currentHybridLanguage]) || {}), botBreakEdited: false, allHybridLanguages: action.data.updatedBotBreakData.meta.all_hybrid_languages });
        case constants_1.REDUCER_ACTIONS.SET_BOTBREAK_TEMPLATE_DATA:
            return __assign(__assign({}, state), { botBreakData: action.data.botBreakData, botBreakEdited: true });
        case constants_1.REDUCER_ACTIONS.SET_GPT_BASED_BOT_BREAK_CHECK:
            return __assign(__assign({}, state), { botBreakData: __assign(__assign({}, state.botBreakData), { enable_gpt_botbreaks: action.data.enableGptBotBreak }) });
        case constants_1.REDUCER_ACTIONS.SET_BOT_BREAK_EDITED:
            return __assign(__assign({}, state), { botBreakEdited: action.data.botBreakEdited });
        case constants_1.REDUCER_ACTIONS.SET_FEEDBACK_MESSAGES_DATA:
            return __assign(__assign({}, state), { feedbackMessagesData: action.data.feedbackMessagesData });
        case constants_1.REDUCER_ACTIONS.SET_FEEDBACK_MESSAGES_EDITED:
            return __assign(__assign({}, state), { feedbackMessagesEdited: action.data.feedbackMessagesEdited });
        case constants_1.REDUCER_ACTIONS.SET_CURRENT_HYBRID_LANGUAGE:
            return __assign(__assign({}, state), { currentHybridLanguage: action.data.currentHybridLanguage, dpsvChannels: ((_j = state.dataUpdatedChannels) === null || _j === void 0 ? void 0 : _j[state.languageCode + "|" + action.data.currentHybridLanguage]) || [], gptDpsvChannels: ((_k = state.gptDataUpdatedChannels) === null || _k === void 0 ? void 0 : _k[state.languageCode + "|" + action.data.currentHybridLanguage]) || [] });
        case constants_1.REDUCER_ACTIONS.SET_CURRENT_CHANNEL:
            return __assign(__assign({}, state), { currentChannel: action.data.id, currentChannelName: action.data.name });
        case constants_1.REDUCER_ACTIONS.SET_TRANSLATE_LOADING:
            return __assign(__assign({}, state), { isTranslateLoading: action.data.flag });
        case constants_1.REDUCER_ACTIONS.SET_DATA_UPDATED_CHANNELS:
            return __assign(__assign({}, state), { dataUpdatedChannels: __assign(__assign({}, state.dataUpdatedChannels), action.data) });
        case constants_1.REDUCER_ACTIONS.SET_GPT_UPDATED_CHANNELS:
            return __assign(__assign({}, state), { gptDataUpdatedChannels: __assign(__assign({}, state.gptDataUpdatedChannels), action.data) });
        case constants_1.REDUCER_ACTIONS.SET_UPDATED_FEEDBACK_CHANNELS:
            return __assign(__assign({}, state), { updatedFeedbackChannels: __assign(__assign({}, state.updatedFeedbackChannels), action.data) });
        case constants_1.REDUCER_ACTIONS.UPDATE_DPSV_CHANNELS:
            return __assign(__assign({}, state), { dpsvChannels: ((_l = state.dataUpdatedChannels) === null || _l === void 0 ? void 0 : _l[state.languageCode + "|" + state.currentHybridLanguage]) || [], gptDpsvChannels: ((_m = state.gptDataUpdatedChannels) === null || _m === void 0 ? void 0 : _m[state.languageCode + "|" + state.currentHybridLanguage]) || [] });
        // #endregion
        default:
            return state;
    }
};
// Actions
var contentManagementActions = function (dispatch, state) { return ({
    // Sets current tab
    setCurrentTab: function (tab) {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_CURRENT_TAB,
            data: { tab: tab },
        });
    },
    // Sets loader active/inactive
    setLoaderActive: function (isLoaderActive) {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_LOADER_ACTIVE,
            data: { isLoaderActive: isLoaderActive },
        });
    },
    // Sets language code
    setLanguageCode: function (languageCode) {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_LANGUAGE_CODE,
            data: { languageCode: languageCode },
        });
    },
    // #region TASKBOX ACTIONS
    // Sets all taskbox data
    setAllTaskBoxData: function (allTaskBoxData) {
        var BUSINESS_TASKS = constants_1.TASKBOX_KEYS.BUSINESS_TASKS, BUSINESS_HEADERS = constants_1.TASKBOX_KEYS.BUSINESS_HEADERS;
        var taskBoxData = allTaskBoxData.body;
        // If header exists for a language but tasks don't, create an empty array for them in get call :)
        Object.keys(taskBoxData[BUSINESS_HEADERS]).forEach(function (key) {
            var _a, _b, _c, _d;
            // Add default task header message if not present
            if (!taskBoxData[BUSINESS_HEADERS][key]) {
                var defaultTaskHeader = (_a = {},
                    _a[key] = 'Hi, I’m your virtual assistant! Here is what I can help you with ?',
                    _a);
                taskBoxData = __assign(__assign({}, taskBoxData), (_b = {}, _b[BUSINESS_HEADERS] = __assign(__assign({}, taskBoxData[BUSINESS_HEADERS]), defaultTaskHeader), _b));
            }
            if (!taskBoxData[BUSINESS_TASKS][key]) {
                // Create an empty array for language code
                var newLanguageData = (_c = {}, _c[key] = [], _c);
                taskBoxData = __assign(__assign({}, taskBoxData), (_d = {}, _d[BUSINESS_TASKS] = __assign(__assign({}, taskBoxData[BUSINESS_TASKS]), newLanguageData), _d));
            }
        });
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_ALL_TASKBOX_DATA,
            data: { allTaskBoxData: allTaskBoxData, taskBoxData: taskBoxData },
        });
    },
    // Set taskbox data
    setTaskBoxData: function (languageCode, key, value, index, isATask) {
        var _a, _b, _c;
        var BUSINESS_TASKS = constants_1.TASKBOX_KEYS.BUSINESS_TASKS, BUSINESS_HEADERS = constants_1.TASKBOX_KEYS.BUSINESS_HEADERS, BUSINESS_TASK_COMPRESS_MENU = constants_1.TASKBOX_KEYS.BUSINESS_TASK_COMPRESS_MENU, BUSINESS_TASK_WELCOME_MESSAGE_DETAILS = constants_1.TASKBOX_KEYS.BUSINESS_TASK_WELCOME_MESSAGE_DETAILS;
        var businessTasks = __assign({}, state.taskBoxData[BUSINESS_TASKS][languageCode]);
        /*
         * Path to traverse for 'updateNestedData' function
         * eg. The following will traverse to:
         *  -- business_tasks.<languageCode>[0]
         */
        var taskPath = [BUSINESS_TASKS, languageCode, index];
        // Business header data
        var businessHeader = __assign(__assign({}, state.taskBoxData[BUSINESS_HEADERS]), (_a = {}, _a[languageCode] = value, _a));
        // Update a particular value
        var updateValue = (_b = {},
            _b[key] = value,
            _b);
        var task = __assign(__assign({}, businessTasks[index]), updateValue);
        if (isATask) {
            // Updates the nested task list
            utils_3.updateNestedData(__assign({}, state.taskBoxData), taskPath, task);
        }
        // Complete updated task data
        var updatedTaskData = __assign(__assign({}, state.taskBoxData), (_c = {}, _c[BUSINESS_TASK_COMPRESS_MENU] = key === BUSINESS_TASK_COMPRESS_MENU
            ? value
            : __assign({}, state.taskBoxData[BUSINESS_TASK_COMPRESS_MENU]), _c[BUSINESS_TASK_WELCOME_MESSAGE_DETAILS] = key === BUSINESS_TASK_WELCOME_MESSAGE_DETAILS
            ? value
            : __assign({}, state.taskBoxData[BUSINESS_TASK_WELCOME_MESSAGE_DETAILS]), _c[BUSINESS_HEADERS] = !isATask &&
            key !== BUSINESS_TASK_COMPRESS_MENU &&
            key !== BUSINESS_TASK_WELCOME_MESSAGE_DETAILS
            ? __assign({}, businessHeader) : __assign({}, state.taskBoxData[BUSINESS_HEADERS]), _c));
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_TASKBOX_DATA,
            data: { updatedTaskData: updatedTaskData },
        });
    },
    // Sets task box edited flag
    setTaskBoxEdited: function (taskBoxEdited) {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_TASK_BOX_EDITED,
            data: { taskBoxEdited: taskBoxEdited },
        });
    },
    // Add new task
    addNewTask: function (languageCode) {
        var BUSINESS_TASKS = constants_1.TASKBOX_KEYS.BUSINESS_TASKS;
        var existingTasks = __spreadArrays(state.taskBoxData[BUSINESS_TASKS][languageCode]);
        existingTasks.forEach(function (task) {
            task.relevance += 1;
        });
        // Add new task on first index in business tasks
        existingTasks.unshift(__assign({}, constants_1.NEW_TASK));
        // Updates the nested task list
        utils_3.updateNestedData(__assign({}, state.taskBoxData), [BUSINESS_TASKS, languageCode], existingTasks);
        var updatedTaskData = __assign({}, state.taskBoxData);
        dispatch({
            type: constants_1.REDUCER_ACTIONS.ADD_NEW_TASK,
            data: {
                updatedTaskData: updatedTaskData,
            },
        });
    },
    // Sorts task list
    sortTaskList: function (languageCode, taskList) {
        var BUSINESS_TASKS = constants_1.TASKBOX_KEYS.BUSINESS_TASKS;
        var updatedTaskList = taskList.map(function (task, i) { return (__assign(__assign({}, task), { relevance: i })); });
        // Updates the nested task list
        utils_3.updateNestedData(__assign({}, state.taskBoxData), [BUSINESS_TASKS, languageCode], updatedTaskList);
        var updatedTaskData = __assign({}, state.taskBoxData);
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SORT_TASK_LIST,
            data: {
                updatedTaskData: updatedTaskData,
            },
        });
    },
    // #endregion
    // #region BOTBREAK ACTIONS
    // Sets all bot break data
    setAllBotBreakData: function (botBreakData) {
        var _a, _b;
        var allBotBreakData = (_a = botBreakData === null || botBreakData === void 0 ? void 0 : botBreakData.body) === null || _a === void 0 ? void 0 : _a.botbreak_templates;
        var gptBotBreakData = (_b = botBreakData === null || botBreakData === void 0 ? void 0 : botBreakData.body) === null || _b === void 0 ? void 0 : _b.gpt_botbreak_templates;
        var updatedBotBreakData = cloneDeep_1["default"](__assign({}, botBreakData));
        var botBreakKeys = Object.keys(allBotBreakData || []);
        var gptBotBreakKeys = Object.keys(gptBotBreakData || []);
        var allUpdatedDataChannels = {};
        var gptBotBreakUpdatedDataChannels = {};
        botBreakKeys.forEach(function (language) {
            var languageData = allBotBreakData[language];
            if (languageData) {
                Object.keys(languageData).forEach(function (item) {
                    var _a, _b, _c;
                    var languageDataKeys = Object.keys(languageData[item]);
                    var updatedChannels = [];
                    // Check if channels key/data is not present in the botbreak_templates
                    if (Array.isArray(languageData[item])) {
                        updatedBotBreakData.body.botbreak_templates[language][item] = (_a = {},
                            _a[constants_1.DEFAULTS.CHANNEL_ID] = languageData[item],
                            _a);
                    }
                    else if (!languageData[item][constants_1.DEFAULTS.CHANNEL_ID]) {
                        updatedBotBreakData.body.botbreak_templates[language][item] = (_b = {},
                            _b[constants_1.DEFAULTS.CHANNEL_ID] = [],
                            _b);
                    }
                    if (languageDataKeys.length > 0) {
                        languageDataKeys.forEach(function (id) {
                            var _a;
                            var channelID = id;
                            // If a new language is added, its 0th index won't be 5
                            if (!languageDataKeys.includes(constants_1.DEFAULTS.CHANNEL_ID)) {
                                channelID = constants_1.DEFAULTS.CHANNEL_ID;
                            }
                            if (((_a = languageData[item][channelID]) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                updatedChannels.push(channelID);
                            }
                        });
                    }
                    allUpdatedDataChannels = __assign(__assign({}, allUpdatedDataChannels), (_c = {}, _c["" + (language + "|" + item)] = updatedChannels, _c));
                });
            }
        });
        gptBotBreakKeys.forEach(function (language) {
            var languageData = gptBotBreakData[language];
            if (languageData) {
                Object.keys(languageData).forEach(function (item) {
                    var _a, _b, _c;
                    var languageDataKeys = Object.keys(languageData[item]);
                    var updatedChannels = [];
                    // Check if channels key/data is not present in the botbreak_templates
                    if (Array.isArray(languageData[item])) {
                        updatedBotBreakData.body.gpt_botbreak_templates[language][item] = (_a = {},
                            _a[constants_1.DEFAULTS.CHANNEL_ID] = languageData[item],
                            _a);
                    }
                    else if (!languageData[item][constants_1.DEFAULTS.CHANNEL_ID]) {
                        updatedBotBreakData.body.gpt_botbreak_templates[language][item] = (_b = {},
                            _b[constants_1.DEFAULTS.CHANNEL_ID] = [],
                            _b);
                    }
                    if (languageDataKeys.length > 0) {
                        languageDataKeys.forEach(function (id) {
                            var _a;
                            var channelID = id;
                            // If a new language is added, its 0th index won't be 5
                            if (!languageDataKeys.includes(constants_1.DEFAULTS.CHANNEL_ID)) {
                                channelID = constants_1.DEFAULTS.CHANNEL_ID;
                            }
                            if (((_a = languageData[item][channelID]) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                updatedChannels.push(channelID);
                            }
                        });
                    }
                    gptBotBreakUpdatedDataChannels = __assign(__assign({}, gptBotBreakUpdatedDataChannels), (_c = {}, _c["" + (language + "|" + item)] = updatedChannels, _c));
                });
            }
        });
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_DATA_UPDATED_CHANNELS,
            data: __assign({}, allUpdatedDataChannels),
        });
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_GPT_UPDATED_CHANNELS,
            data: __assign({}, gptBotBreakUpdatedDataChannels),
        });
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_ALL_BOTBREAK_DATA,
            data: { updatedBotBreakData: updatedBotBreakData },
        });
    },
    setAllFeedbackMessagesData: function (feedbackMessagesData) {
        var allUpdatedChannels = {};
        Object.keys(feedbackMessagesData.bot).forEach(function (language) {
            Object.keys(feedbackMessagesData.bot[language]).forEach(function (hybridLanguage) {
                var _a;
                var languageData = feedbackMessagesData.bot[language][hybridLanguage];
                var channels = [];
                Object.keys(languageData).map(function (channel) {
                    channels.push(channel);
                });
                allUpdatedChannels = __assign(__assign({}, allUpdatedChannels), (_a = {}, _a[language + "|" + hybridLanguage] = channels, _a));
            });
        });
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_FEEDBACK_MESSAGES_DATA,
            data: { feedbackMessagesData: feedbackMessagesData },
        });
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_UPDATED_FEEDBACK_CHANNELS,
            data: allUpdatedChannels,
        });
    },
    setFeedbackMessagesEdited: function (feedbackMessagesEdited) {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_FEEDBACK_MESSAGES_EDITED,
            data: { feedbackMessagesEdited: feedbackMessagesEdited },
        });
    },
    setFeedbackMessagesData: function (languageCode, type, response, channelId, setEdited) {
        var feedbackMessagesData = __assign({}, state.feedbackMessagesData);
        var updatedFeedbackChannels = __assign({}, state.updatedFeedbackChannels);
        var hybridLangCode = languageCode + "|" + state.currentHybridLanguage;
        if (!feedbackMessagesData[type][languageCode])
            feedbackMessagesData[type][languageCode] = {};
        if (!feedbackMessagesData[type][languageCode][state.currentHybridLanguage])
            feedbackMessagesData[type][languageCode][state.currentHybridLanguage] = {};
        feedbackMessagesData[type][languageCode][state.currentHybridLanguage][channelId] = response ? [response] : [];
        if (setEdited &&
            !updatedFeedbackChannels[hybridLangCode].includes(channelId)) {
            updatedFeedbackChannels[hybridLangCode].push(channelId.toString());
            dispatch({
                type: constants_1.REDUCER_ACTIONS.SET_UPDATED_FEEDBACK_CHANNELS,
                data: updatedFeedbackChannels,
            });
        }
        if (setEdited)
            dispatch({
                type: constants_1.REDUCER_ACTIONS.SET_FEEDBACK_MESSAGES_EDITED,
                data: { feedbackMessagesEdited: true },
            });
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_FEEDBACK_MESSAGES_DATA,
            data: { feedbackMessagesData: feedbackMessagesData },
        });
    },
    // Sets bot break template data
    setBotBreakTemplateData: function (languageCode, value, setEdited, channelID, isGptBotBreak) {
        var _a, _b, _c, _d, _e, _f;
        var botBreakData = __assign({}, state.botBreakData);
        var updatedDataChannelKey = "" + (languageCode + "|" + state.currentHybridLanguage);
        var channel = channelID || state.currentChannel;
        if (!isGptBotBreak) {
            botBreakData.botbreak_templates[languageCode] = __assign(__assign({}, botBreakData.botbreak_templates[languageCode]), (_a = {}, _a[state.currentHybridLanguage] = __assign(__assign({}, botBreakData.botbreak_templates[languageCode][state.currentHybridLanguage]), (_b = {}, _b[channel] = value, _b)), _a));
        }
        else {
            botBreakData.gpt_botbreak_templates[languageCode] = __assign(__assign({}, botBreakData.gpt_botbreak_templates[languageCode]), (_c = {}, _c[state.currentHybridLanguage] = __assign(__assign({}, botBreakData.gpt_botbreak_templates[languageCode][state.currentHybridLanguage]), (_d = {}, _d[channel] = value, _d)), _c));
        }
        if (!isGptBotBreak &&
            setEdited &&
            state.dataUpdatedChannels[updatedDataChannelKey] !== undefined) {
            var currentUpdatedChannels = __spreadArrays(state.dataUpdatedChannels[updatedDataChannelKey]);
            if (!currentUpdatedChannels.includes(channel.toString())) {
                currentUpdatedChannels.push(channel.toString());
            }
            if (value.length === 0 || (value.length === 1 && value[0] === '')) {
                var channelString = channel.toString();
                if (currentUpdatedChannels.indexOf(channelString) !== -1)
                    currentUpdatedChannels.splice(currentUpdatedChannels.indexOf(channelString), 1);
            }
            dispatch({
                type: constants_1.REDUCER_ACTIONS.SET_DATA_UPDATED_CHANNELS,
                data: (_e = {},
                    _e["" + (languageCode + "|" + state.currentHybridLanguage)] = currentUpdatedChannels,
                    _e),
            });
        }
        if (isGptBotBreak &&
            setEdited &&
            state.gptDataUpdatedChannels[updatedDataChannelKey] !== undefined) {
            var currentUpdatedChannels = __spreadArrays(state.gptDataUpdatedChannels[updatedDataChannelKey]);
            if (!currentUpdatedChannels.includes(channel.toString())) {
                currentUpdatedChannels.push(channel.toString());
            }
            if (value.length === 0 || (value.length === 1 && value[0] === '')) {
                var channelString = channel.toString();
                if (currentUpdatedChannels.indexOf(channelString) !== -1)
                    currentUpdatedChannels.splice(currentUpdatedChannels.indexOf(channelString), 1);
            }
            dispatch({
                type: constants_1.REDUCER_ACTIONS.SET_GPT_UPDATED_CHANNELS,
                data: (_f = {},
                    _f["" + (languageCode + "|" + state.currentHybridLanguage)] = currentUpdatedChannels,
                    _f),
            });
        }
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_BOTBREAK_TEMPLATE_DATA,
            data: { botBreakData: botBreakData },
        });
    },
    // Sets bot break edited flag
    setBotBreakEdited: function (botBreakEdited) {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_BOT_BREAK_EDITED,
            data: { botBreakEdited: botBreakEdited },
        });
    },
    // Sets bot break's hybrid language
    setCurrentHybridLanguage: function (currentHybridLanguage) {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_CURRENT_HYBRID_LANGUAGE,
            data: { currentHybridLanguage: currentHybridLanguage },
        });
    },
    // Sets bot break's hybrid language
    setCurrentChannel: function (id, name) {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_CURRENT_CHANNEL,
            data: { id: id, name: name },
        });
    },
    // Sets loading state for translate call
    setTranslateLoading: function (flag) {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_TRANSLATE_LOADING,
            data: { flag: flag },
        });
    },
    // Sets list of channels whose data is updated
    setDataUpdatedChannels: function (channels) {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_DATA_UPDATED_CHANNELS,
            data: { channels: channels },
        });
    },
    // Update list of dpsv Chaneels once edited changes are saved
    updateDPSVChannels: function () {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.UPDATE_DPSV_CHANNELS,
        });
    },
}); };
var ContentManagement = function (_a) {
    var activateConfirmationDialog = _a.activateConfirmationDialog;
    var _b = react_redux_1.useSelector(maps_1.stateToProps), businessId = _b.businessId, viaName = _b.viaName, activePartners = _b.activePartners;
    var _c = react_1["default"].useReducer(reducer, initialState), state = _c[0], dispatch = _c[1];
    var actions = contentManagementActions(dispatch, state);
    var currentTab = state.currentTab, isLoaderActive = state.isLoaderActive, allTaskBoxData = state.allTaskBoxData, languageCode = state.languageCode, taskBoxData = state.taskBoxData, taskBoxEdited = state.taskBoxEdited, allLanguages = state.allLanguages, botBreakData = state.botBreakData, feedbackMessagesData = state.feedbackMessagesData, feedbackMessagesEdited = state.feedbackMessagesEdited, updatedFeedbackChannels = state.updatedFeedbackChannels, botBreakEdited = state.botBreakEdited, allHybridLanguages = state.allHybridLanguages, currentHybridLanguage = state.currentHybridLanguage, currentChannel = state.currentChannel, isTranslateLoading = state.isTranslateLoading, currentChannelName = state.currentChannelName, dataUpdatedChannels = state.dataUpdatedChannels, gptDataUpdatedChannels = state.gptDataUpdatedChannels, dpsvChannels = state.dpsvChannels, gptDpsvChannels = state.gptDpsvChannels;
    var setAllFeedbackMessagesData = actions.setAllFeedbackMessagesData, setFeedbackMessagesData = actions.setFeedbackMessagesData, setFeedbackMessagesEdited = actions.setFeedbackMessagesEdited, setLoaderActive = actions.setLoaderActive, setTranslateLoading = actions.setTranslateLoading;
    var isAgentFeedbackEnabled = store_1["default"].getFeatureFlag(MogamboConstants_1.FEATURE_FLAG_DATA.FLAGS.ENABLE_AGENT_FEEDBACK_MESSAGES);
    // Update language value in the dropdown
    var getSelectedLanguage = function (code) {
        var language;
        allLanguages.forEach(function (item) {
            if (item.language_code === code) {
                language = item;
            }
        });
        return language.name;
    };
    // Update language
    var handleLanguageChange = function (language) {
        if (botBreakEdited || feedbackMessagesEdited) {
            BotActions_1.createAlert('Please save changes first to change language', 3000, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        var language_code = language.language_code;
        var hybridLanguage = language_code;
        if (taskBoxData[constants_1.TASKBOX_KEYS.BUSINESS_TASKS][language_code] === undefined) {
            actions.setTaskBoxData(language_code);
        }
        actions.setLanguageCode(language_code);
        actions.setCurrentChannel(constants_1.DEFAULTS.CHANNEL_ID, constants_1.DEFAULTS.CHANNEL_NAME);
        if (allHybridLanguages[language_code] &&
            allHybridLanguages[language_code].length > 1) {
            hybridLanguage = allHybridLanguages[language_code][0].script;
        }
        actions.setCurrentHybridLanguage(hybridLanguage);
    };
    // Update tab view
    var handleTabChange = function (tab) {
        actions.setCurrentTab(tab);
        actions.setCurrentChannel(constants_1.DEFAULTS.CHANNEL_ID, constants_1.DEFAULTS.CHANNEL_NAME);
    };
    // #region TASKBOX EVENTS
    // Get taskbox data
    var getTasks = function () {
        index_1.API.businessV2
            .getTasks(businessId)
            .then(function (_a) {
            var success = _a.success, response = _a.response;
            if (success) {
                var updatedResponse = __assign({}, response);
                actions.setAllTaskBoxData(updatedResponse);
                actions.setLoaderActive(false);
            }
            else {
                actions.setLoaderActive(false);
                BotActions_1.createAlert(response.error, undefined, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
        })["catch"](function (error) {
            actions.setLoaderActive(false);
            BotActions_1.createAlert(error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
        });
    };
    // Handle task data changes
    var handleTaskBoxChange = function (key, value, index, isATask) {
        actions.setTaskBoxData(languageCode, key, value, index, isATask);
    };
    // Add new task
    var addNewTask = function () {
        actions.addNewTask(languageCode);
    };
    // Sort Task list
    var sortTaskList = function (code, taskList) {
        actions.sortTaskList(code, taskList);
    };
    // Validate taskbox headers
    var validateTaskHeaders = function () {
        var errors = [];
        var taskHeaders = __assign({}, taskBoxData[constants_1.TASKBOX_KEYS.BUSINESS_HEADERS]);
        // eslint-disable-next-line array-callback-return
        Object.keys(taskHeaders).map(function (key) {
            if (!taskHeaders[key]) {
                errors.push(getSelectedLanguage(key));
            }
        });
        return errors;
    };
    // Validate task info
    var validateTasks = function () {
        var errors = [];
        var allTasks = __assign({}, taskBoxData[constants_1.TASKBOX_KEYS.BUSINESS_TASKS]);
        var TASK_NAME = constants_1.TASKBOX_KEYS.TASK_NAME, USER_SAYS = constants_1.TASKBOX_KEYS.USER_SAYS, TASK_RULES = constants_1.TASKBOX_KEYS.TASK_RULES;
        allLanguages.forEach(function (langauge) {
            var code = langauge.language_code;
            allTasks[code].forEach(function (item) {
                var languageName = getSelectedLanguage(code);
                if (!item[TASK_NAME]) {
                    if (!errors.includes(languageName)) {
                        errors.push(languageName);
                    }
                }
                else if (!item[USER_SAYS]) {
                    if (!errors.includes(languageName)) {
                        errors.push(languageName);
                    }
                }
                else if (item[TASK_RULES] && item[TASK_RULES].enabled) {
                    item[TASK_RULES].rule_list.forEach(function (_a) {
                        var variable = _a.variable, meta = _a.meta, operator = _a.operator, value = _a.value;
                        if (!errors.includes(languageName) &&
                            !const_2.FIXED_VALUE_OPERATORS[operator] &&
                            !value.trim()) {
                            errors.push(languageName);
                        }
                        else if (!errors.includes(languageName) &&
                            variable === 'query_param') {
                            if (!meta.key || meta.key.trim() === '')
                                errors.push(languageName);
                        }
                    });
                }
            });
        });
        return errors;
    };
    // Update taskbox data
    var updateTasks = function (updateBotBreak) {
        var taskHeaderErrors = validateTaskHeaders();
        var taskErrors = validateTasks();
        if (taskHeaderErrors.length > 0) {
            BotActions_1.createAlert("Menu message not defined for: " + taskHeaderErrors
                .toString()
                .replace(/,/g, ', '), undefined, MogamboConstants_1.AlertTypes.NEGATIVE);
        }
        else if (taskErrors.length > 0) {
            BotActions_1.createAlert("Tasks have empty data for: " + taskErrors
                .toString()
                .replace(/,/g, ', '), undefined, MogamboConstants_1.AlertTypes.NEGATIVE);
        }
        else {
            actions.setLoaderActive(true);
            index_1.API.businessV2
                .updateTasks(businessId, taskBoxData)
                .then(function (_a) {
                var success = _a.success, response = _a.response;
                if (success) {
                    actions.setTaskBoxEdited(false);
                    if (updateBotBreak) {
                        updateBotBreakTemplates();
                    }
                    else {
                        actions.setAllTaskBoxData(response);
                        BotActions_1.createAlert('Changes saved successfully!', undefined, MogamboConstants_1.AlertTypes.POSITIVE);
                        actions.setLoaderActive(false);
                    }
                }
                else {
                    actions.setLoaderActive(false);
                    BotActions_1.createAlert(response.error, undefined, MogamboConstants_1.AlertTypes.NEGATIVE);
                }
            })["catch"](function (error) {
                actions.setLoaderActive(false);
                BotActions_1.createAlert(error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
            });
        }
    };
    // #endregion
    // #region BOT BREAK EVENTS
    // Get bot break templates
    var getBotBreakTemplates = function () {
        index_1.API.businessV2
            .getBotBreakTemplates(businessId)
            .then(function (_a) {
            var success = _a.success, response = _a.response;
            if (success) {
                actions.setAllBotBreakData(response);
                actions.setLoaderActive(false);
            }
            else {
                actions.setLoaderActive(false);
                BotActions_1.createAlert(response.error, undefined, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
        })["catch"](function (error) {
            actions.setLoaderActive(false);
            BotActions_1.createAlert(error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
        });
    };
    // Get feedback messages
    var getFeedbackMessages = function () {
        index_1.API.businessV2
            .getFeedbackMessages(businessId)
            .then(function (_a) {
            var _b;
            var success = _a.success, response = _a.response;
            if (success && response.body) {
                setAllFeedbackMessagesData((_b = response.body) === null || _b === void 0 ? void 0 : _b.feedback_messages);
                setFeedbackMessagesEdited(false);
                setLoaderActive(false);
            }
            else {
                setLoaderActive(false);
                BotActions_1.createAlert(response.error || 'Something went wrong!', undefined, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
        })["catch"](function (error) {
            setLoaderActive(false);
            BotActions_1.createAlert(error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
        });
    };
    // Bot break template change
    var handleBotBreakChange = function (value, isGptBotBreak) {
        actions.setBotBreakTemplateData(languageCode, value, true, null, isGptBotBreak);
    };
    var handleFeedbackMessagesChange = function (value, type, channelId) {
        setFeedbackMessagesData(languageCode, type, value, channelId, true);
    };
    // Delete empty keys from Bot Break Templates
    var delEmptyBotBreakKeys = function (data) {
        var updatedData = cloneDeep_1["default"](__assign({}, data));
        var keys = Object.keys(updatedData.botbreak_templates);
        var gptKeys = Object.keys(updatedData.gpt_botbreak_templates);
        keys.forEach(function (item) {
            var innerData = updatedData.botbreak_templates[item];
            var innerKeys = Object.keys(innerData);
            innerKeys.forEach(function (hybridLang) {
                var channels = Object.keys(innerData[hybridLang]);
                var updatedDataChannelKey = "" + (item + "|" + hybridLang);
                channels.forEach(function (channel) {
                    var _a, _b, _c;
                    if (channel !== constants_1.DEFAULTS.CHANNEL_ID &&
                        (((_a = innerData[hybridLang][channel]) === null || _a === void 0 ? void 0 : _a.length) === 0 ||
                            !dataUpdatedChannels[updatedDataChannelKey].includes(channel))) {
                        delete updatedData.botbreak_templates[item][hybridLang][channel];
                    }
                    if (channel === constants_1.DEFAULTS.CHANNEL_ID &&
                        (((_b = innerData[hybridLang][channel]) === null || _b === void 0 ? void 0 : _b.length) === 0 ||
                            ((_c = innerData[hybridLang][channel]) === null || _c === void 0 ? void 0 : _c[0]) === '')) {
                        BotActions_1.createAlert("Please add responses for WebSDK for language code " + item, null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        updatedData.error = true;
                    }
                });
            });
        });
        gptKeys.forEach(function (item) {
            var innerData = updatedData.gpt_botbreak_templates[item];
            var innerKeys = Object.keys(innerData);
            innerKeys.forEach(function (hybridLang) {
                var channels = Object.keys(innerData[hybridLang]);
                var updatedDataChannelKey = "" + (item + "|" + hybridLang);
                channels.forEach(function (channel) {
                    var _a, _b, _c, _d;
                    if (channel !== constants_1.DEFAULTS.CHANNEL_ID &&
                        (((_a = innerData[hybridLang][channel]) === null || _a === void 0 ? void 0 : _a.length) === 0 ||
                            !gptDataUpdatedChannels[updatedDataChannelKey].includes(channel))) {
                        delete updatedData.gpt_botbreak_templates[item][hybridLang][channel];
                    }
                    if (channel === constants_1.DEFAULTS.CHANNEL_ID &&
                        ((_b = innerData[hybridLang][channel]) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                        ((_d = (_c = innerData[hybridLang][channel]) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.trim()) === '') {
                        updatedData.gpt_botbreak_templates[item][hybridLang][channel][0] =
                            '';
                    }
                });
            });
        });
        return updatedData;
    };
    // Remove channel keys and restructure to older data format
    var removeChannelKeys = function (data) {
        var updatedData = cloneDeep_1["default"](__assign({}, data));
        var keys = Object.keys(updatedData.botbreak_templates);
        keys.forEach(function (item) {
            var innerData = updatedData.botbreak_templates[item];
            var innerKeys = Object.keys(innerData);
            innerKeys.forEach(function (hybridLang) {
                updatedData.botbreak_templates[item][hybridLang] =
                    innerData[hybridLang]['5'];
            });
        });
        return updatedData;
    };
    var cleanedFeedbackMessages = function (feedbackMessages) {
        var cleanedFeedbackMessagesData = feedbackMessages;
        var botFeedbackMessages = cleanedFeedbackMessagesData.bot;
        Object.keys(botFeedbackMessages).forEach(function (language) {
            Object.keys(botFeedbackMessages[language]).forEach(function (hybridLanguage) {
                Object.keys(botFeedbackMessages[language][hybridLanguage]).forEach(function (channel) {
                    if (!updatedFeedbackChannels[language + "|" + hybridLanguage].includes(channel.toString())) {
                        delete cleanedFeedbackMessagesData.bot[language][hybridLanguage][channel];
                        delete cleanedFeedbackMessagesData.agent[language][hybridLanguage][channel];
                    }
                });
            });
        });
        return feedbackMessages;
    };
    var isAnyEmptyFeedbackMessage = function (type) {
        var isEmpty = false;
        var feedbackMessages = feedbackMessagesData[type];
        Object.keys(feedbackMessages).forEach(function (language) {
            Object.keys(feedbackMessages[language]).forEach(function (hybridLanguage) {
                var hybridLanguageKey = language + "|" + hybridLanguage;
                var updatedChannels = updatedFeedbackChannels[hybridLanguageKey];
                Object.keys(feedbackMessages[language][hybridLanguage]).forEach(function (channelId) {
                    var _a;
                    if (updatedChannels.includes(channelId) &&
                        ((_a = feedbackMessages[language][hybridLanguage][channelId]) === null || _a === void 0 ? void 0 : _a.length) ===
                            0) {
                        isEmpty = true;
                    }
                });
            });
        });
        if (isEmpty) {
            BotActions_1.createAlert("Please add feedback message for " + type + "s.", 3000, MogamboConstants_1.AlertTypes.NEGATIVE);
            return true;
        }
        return false;
    };
    // Update bot break templates
    var updateFeedbackMessages = function () {
        if (isAnyEmptyFeedbackMessage('bot') || isAnyEmptyFeedbackMessage('agent'))
            return;
        setLoaderActive(true);
        index_1.API.businessV2
            .updateFeedbackMessages(businessId, {
            feedback_messages: cleanedFeedbackMessages(state.feedbackMessagesData),
        })
            .then(function (_a) {
            var success = _a.success, response = _a.response;
            if (success) {
                BotActions_1.createAlert('Changes saved successfully!', undefined, MogamboConstants_1.AlertTypes.POSITIVE);
                setLoaderActive(false);
                setFeedbackMessagesEdited(false);
            }
            else {
                setLoaderActive(false);
                BotActions_1.createAlert(response.error, undefined, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
        })["catch"](function (error) {
            setLoaderActive(false);
            BotActions_1.createAlert(error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
        });
    };
    // Update bot break templates
    var updateBotBreakTemplates = function () {
        var updatedBotBreakData = delEmptyBotBreakKeys(__assign({}, botBreakData));
        updatedBotBreakData.version = '3';
        if (updatedBotBreakData.error) {
            return;
        }
        actions.setLoaderActive(true);
        delete updatedBotBreakData.error;
        index_1.API.businessV2
            .updateBotBreakTemplates(businessId, updatedBotBreakData)
            .then(function (_a) {
            var _b, _c, _d, _e, _f;
            var success = _a.success, response = _a.response;
            if (success) {
                BotActions_1.createAlert('Changes saved successfully!', undefined, MogamboConstants_1.AlertTypes.POSITIVE);
                actions.setLoaderActive(false);
                actions.setBotBreakEdited(false);
                actions.updateDPSVChannels();
                // Mixpanel Event for Reset of Bot Breaks
                var currentBotBreakMessages_1 = (_c = (_b = botBreakData === null || botBreakData === void 0 ? void 0 : botBreakData.botbreak_templates) === null || _b === void 0 ? void 0 : _b[languageCode]) === null || _c === void 0 ? void 0 : _c[currentHybridLanguage];
                var business_1 = (_d = store_1["default"].getBusinessesLinkedToBot()) === null || _d === void 0 ? void 0 : _d[0];
                if (currentBotBreakMessages_1) {
                    var meta_1 = CommonStore_1["default"].getMetaTags();
                    var isResetAction_1 = false;
                    // Mixpanel Event for Reset
                    Object.keys(currentBotBreakMessages_1).forEach(function (channel) {
                        var _a, _b;
                        if (!currentBotBreakMessages_1[channel].length) {
                            var mixPanelTracker = store_1["default"].getMixPanel();
                            mixPanelTracker.track({
                                event: const_1.MIX_PANEL.OMNICHANNEL.RESET,
                                payload: {
                                    'Bot Name': (_a = meta_1 === null || meta_1 === void 0 ? void 0 : meta_1.domain) === null || _a === void 0 ? void 0 : _a.title,
                                    'Bot Account': (_b = meta_1 === null || meta_1 === void 0 ? void 0 : meta_1.domain) === null || _b === void 0 ? void 0 : _b.client,
                                    'Business ID': business_1 === null || business_1 === void 0 ? void 0 : business_1.id,
                                    'Business Name': business_1 === null || business_1 === void 0 ? void 0 : business_1.via_name,
                                    'Channel Name': currentChannelName,
                                },
                            });
                            isResetAction_1 = true;
                        }
                    });
                    // Mixpanel Event for Add Bot Break Messages
                    if (!isResetAction_1) {
                        var mixPanelTracker = store_1["default"].getMixPanel();
                        mixPanelTracker.track({
                            event: const_1.MIX_PANEL.OMNICHANNEL.ACTIVITY,
                            payload: {
                                'Bot Name': (_e = meta_1 === null || meta_1 === void 0 ? void 0 : meta_1.domain) === null || _e === void 0 ? void 0 : _e.title,
                                'Bot Account': (_f = meta_1 === null || meta_1 === void 0 ? void 0 : meta_1.domain) === null || _f === void 0 ? void 0 : _f.client,
                                'Business ID': business_1 === null || business_1 === void 0 ? void 0 : business_1.id,
                                'Business Name': business_1 === null || business_1 === void 0 ? void 0 : business_1.via_name,
                                'Channel Name': currentChannelName,
                            },
                        });
                    }
                }
            }
            else {
                actions.setLoaderActive(false);
                BotActions_1.createAlert(response.error, undefined, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
        })["catch"](function (error) {
            actions.setLoaderActive(false);
            BotActions_1.createAlert(error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
        });
    };
    // Handle Hybrid language script change
    var handleHybridLanguageScriptChange = function (script) {
        actions.setCurrentHybridLanguage(script);
        actions.setCurrentChannel(constants_1.DEFAULTS.CHANNEL_ID, constants_1.DEFAULTS.CHANNEL_NAME);
    };
    // Handle OC Dropdown Change
    var handleOCDropdownChange = function (id, name) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var botBreakVariants = __spreadArrays(botBreakData.botbreak_templates[languageCode][currentHybridLanguage][constants_1.DEFAULTS.CHANNEL_ID]);
        var gptBotBreakVariants = __spreadArrays(botBreakData.gpt_botbreak_templates[languageCode][currentHybridLanguage][constants_1.DEFAULTS.CHANNEL_ID]);
        var botFeedbackMessages = __spreadArrays((((_c = (_b = (_a = feedbackMessagesData.bot) === null || _a === void 0 ? void 0 : _a[languageCode]) === null || _b === void 0 ? void 0 : _b[currentHybridLanguage]) === null || _c === void 0 ? void 0 : _c[constants_1.DEFAULTS.CHANNEL_ID]) || []));
        var agentFeedbackMessages = __spreadArrays((((_f = (_e = (_d = feedbackMessagesData.agent) === null || _d === void 0 ? void 0 : _d[languageCode]) === null || _e === void 0 ? void 0 : _e[currentHybridLanguage]) === null || _f === void 0 ? void 0 : _f[constants_1.DEFAULTS.CHANNEL_ID]) || []));
        // If WebSDK does not contain variants
        if (botBreakVariants.length === 0 || botBreakVariants[0] === '{}') {
            BotActions_1.createAlert('Please add bot responses within WebSDK to proceed', 3000, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        if (botFeedbackMessages.length === 0 ||
            agentFeedbackMessages.length === 0) {
            BotActions_1.createAlert('Please add feedback message within WebSDK to proceed', 3000, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        // If WebSDK responses are not saved
        if (botBreakEdited && currentChannel.toString() === constants_1.DEFAULTS.CHANNEL_ID) {
            BotActions_1.createAlert('Please save bot responses in WebSDK to proceed', 3000, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        if (feedbackMessagesEdited &&
            currentChannel.toString() === constants_1.DEFAULTS.CHANNEL_ID) {
            BotActions_1.createAlert('Please save feedback messages in WebSDK to proceed', 3000, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        actions.setCurrentChannel(id, name);
        var testConfigData = store_1["default"].getTestConfigData();
        var domainName = CommonStore_1["default"].getMetaTags().domain.title;
        var updatedDataChannelKey = "" + (languageCode + "|" + currentHybridLanguage);
        if (currentTab === constants_1.TABS.BOT_BREAK) {
            var currentUpdatedDataChannels = __spreadArrays(dataUpdatedChannels[updatedDataChannelKey]);
            var currentUpdatedGptChannels = __spreadArrays(gptDataUpdatedChannels[updatedDataChannelKey]);
            var payload = {};
            var translatePayload = false;
            var gptTranslatePayload = false;
            payload.target_device_platform_id = id;
            payload.business_id = botBreakData === null || botBreakData === void 0 ? void 0 : botBreakData.business_id;
            payload.client_id = testConfigData === null || testConfigData === void 0 ? void 0 : testConfigData.partner_client_id;
            payload.domain_name = domainName;
            var hybridLangData = botBreakData.botbreak_templates[languageCode][currentHybridLanguage][id];
            var hybridGptLangData = botBreakData.gpt_botbreak_templates[languageCode][currentHybridLanguage][id];
            if (!currentUpdatedDataChannels.includes(id.toString()) ||
                hybridLangData === undefined ||
                (hybridLangData === null || hybridLangData === void 0 ? void 0 : hybridLangData.length) === 0) {
                translatePayload = true;
                payload.botBreaks = {
                    variants: botBreakVariants,
                };
            }
            if (!currentUpdatedGptChannels.includes(id.toString()) ||
                hybridGptLangData === undefined ||
                (hybridGptLangData === null || hybridGptLangData === void 0 ? void 0 : hybridGptLangData.length) === 0) {
                gptTranslatePayload = true;
                payload.gptBotBreaks = {
                    variants: gptBotBreakVariants,
                };
            }
            if (translatePayload || gptTranslatePayload) {
                actions.setTranslateLoading(true);
                DomainAPI_1.getTranslations(payload).then(function (_a) {
                    var _b, _c, _d, _e;
                    var success = _a.success, response = _a.response;
                    if (success && ((_c = (_b = response === null || response === void 0 ? void 0 : response.body) === null || _b === void 0 ? void 0 : _b.botBreaks) === null || _c === void 0 ? void 0 : _c.variants)) {
                        actions.setBotBreakTemplateData(languageCode, response.body.botBreaks.variants, false, id, false);
                    }
                    if (success && ((_e = (_d = response === null || response === void 0 ? void 0 : response.body) === null || _d === void 0 ? void 0 : _d.gptBotBreaks) === null || _e === void 0 ? void 0 : _e.variants)) {
                        actions.setBotBreakTemplateData(languageCode, response.body.gptBotBreaks.variants, false, id, true);
                    }
                    actions.setBotBreakEdited(false);
                    actions.setTranslateLoading(false);
                });
            }
        }
        else {
            var currentUpdatedDataChannels = __spreadArrays(updatedFeedbackChannels[updatedDataChannelKey]);
            var botPayload = {};
            var agentPayload = {};
            var commonPayloads = {
                target_device_platform_id: id,
                business_id: testConfigData === null || testConfigData === void 0 ? void 0 : testConfigData.business_id,
                client_id: testConfigData === null || testConfigData === void 0 ? void 0 : testConfigData.partner_client_id,
                domain_name: domainName,
            };
            var translatePayload = false;
            botPayload.feedbackMessages = {
                variants: botFeedbackMessages,
            };
            agentPayload.feedbackMessages = {
                variants: agentFeedbackMessages,
            };
            var hybridLangData = (_j = (_h = (_g = feedbackMessagesData.bot) === null || _g === void 0 ? void 0 : _g[languageCode]) === null || _h === void 0 ? void 0 : _h[currentHybridLanguage]) === null || _j === void 0 ? void 0 : _j[id];
            if (!currentUpdatedDataChannels.includes(id.toString()) ||
                hybridLangData === undefined ||
                (hybridLangData === null || hybridLangData === void 0 ? void 0 : hybridLangData.length) === 0) {
                translatePayload = true;
            }
            if (translatePayload) {
                setTranslateLoading(true);
                DomainAPI_1.getTranslations(__assign(__assign({}, botPayload), commonPayloads)).then(function (_a) {
                    var _b, _c;
                    var success = _a.success, response = _a.response;
                    if (success && ((_c = (_b = response === null || response === void 0 ? void 0 : response.body) === null || _b === void 0 ? void 0 : _b.feedbackMessages) === null || _c === void 0 ? void 0 : _c.variants)) {
                        setFeedbackMessagesData(languageCode, 'bot', response.body.feedbackMessages.variants[0], id, false);
                    }
                    setTranslateLoading(false);
                });
                if (isAgentFeedbackEnabled) {
                    DomainAPI_1.getTranslations(__assign(__assign({}, agentPayload), commonPayloads)).then(function (_a) {
                        var _b, _c;
                        var success = _a.success, response = _a.response;
                        if (success && ((_c = (_b = response === null || response === void 0 ? void 0 : response.body) === null || _b === void 0 ? void 0 : _b.feedbackMessages) === null || _c === void 0 ? void 0 : _c.variants)) {
                            setFeedbackMessagesData(languageCode, 'agent', response.body.feedbackMessages.variants[0], id, false);
                        }
                        setTranslateLoading(false);
                    });
                }
            }
        }
    };
    // #endregion
    // Handle save action
    var handleSave = function () {
        if (taskBoxEdited && botBreakEdited) {
            updateTasks(true);
        }
        else if (taskBoxEdited) {
            updateTasks();
        }
        else if (botBreakEdited) {
            updateBotBreakTemplates();
        }
        if (feedbackMessagesEdited)
            updateFeedbackMessages();
    };
    react_1["default"].useEffect(function () {
        getTasks();
        getBotBreakTemplates();
        getFeedbackMessages();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Get bot break messages component
    var renderBotBreakMessages = function () {
        var languageSource = languageCode;
        var hybridLanguages = allHybridLanguages[languageCode] &&
            allHybridLanguages[languageCode].length > 1 &&
            allHybridLanguages[languageCode];
        var template = botBreakData.botbreak_templates[languageSource][currentHybridLanguage];
        var gptTemplate = botBreakData.gpt_botbreak_templates[languageSource][currentHybridLanguage];
        var templateValue = template
            ? template[currentChannel] || ''
            : '';
        var gptTemplateValue = gptTemplate
            ? gptTemplate[currentChannel] || ''
            : '';
        if (!templateValue || templateValue[0] === '{}') {
            templateValue = [];
        }
        if (!gptTemplateValue || gptTemplateValue[0] === '{}') {
            gptTemplateValue = [];
        }
        var isTranslated = parseInt(currentChannel, 10) !== 5 &&
            !dpsvChannels.includes(currentChannel.toString());
        var isGptTranslated = parseInt(currentChannel, 10) !== 5 &&
            !gptDpsvChannels.includes(currentChannel.toString());
        return (react_1["default"].createElement(BotBreakMessages_1["default"], { gptValue: gptTemplateValue, value: templateValue, onChange: handleBotBreakChange, disabled: utils_1.isProduction(), hybridLanguages: hybridLanguages, handleHybridLanguageScriptChange: handleHybridLanguageScriptChange, currentHybridLanguage: currentHybridLanguage, languageSource: languageSource, handleOCDropdownChange: handleOCDropdownChange, currentChannel: currentChannel, isTranslateLoading: isTranslateLoading, currentChannelName: currentChannelName, webSDKSaved: template[constants_1.DEFAULTS.CHANNEL_ID].length === 0 ||
                (botBreakEdited &&
                    currentChannel.toString() === constants_1.DEFAULTS.CHANNEL_ID) ||
                template[constants_1.DEFAULTS.CHANNEL_ID][0] === '{}', isTranslated: isTranslated, isGptTranslated: isGptTranslated, isGptBotBreakEnable: botBreakData.enable_gpt_botbreaks, onGptBasedCheckChange: function (value) {
                dispatch({
                    type: constants_1.REDUCER_ACTIONS.SET_GPT_BASED_BOT_BREAK_CHECK,
                    data: { enableGptBotBreak: value },
                });
                actions.setBotBreakEdited(true);
            } }));
    };
    var renderFeedbackMessages = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var languageSource = languageCode;
        var hybridLanguages = allHybridLanguages[languageCode] &&
            allHybridLanguages[languageCode].length > 1 &&
            allHybridLanguages[languageCode];
        var botFeedbackMessages = ((_b = (_a = feedbackMessagesData.bot[languageSource]) === null || _a === void 0 ? void 0 : _a[currentHybridLanguage]) === null || _b === void 0 ? void 0 : _b[currentChannel]) || [];
        var agentFeedbackMessages = ((_d = (_c = feedbackMessagesData.agent[languageSource]) === null || _c === void 0 ? void 0 : _c[currentHybridLanguage]) === null || _d === void 0 ? void 0 : _d[currentChannel]) || [];
        var isTranslated = parseInt(currentChannel, 10) !== 5 &&
            !dpsvChannels.includes(currentChannel.toString());
        return (react_1["default"].createElement(FeedbackMessages_1["default"], { botFeedbackMessages: botFeedbackMessages, agentFeedbackMessages: agentFeedbackMessages, onChange: handleFeedbackMessagesChange, disabled: utils_1.isProduction(), hybridLanguages: hybridLanguages, handleHybridLanguageScriptChange: handleHybridLanguageScriptChange, currentHybridLanguage: currentHybridLanguage, languageSource: languageSource, handleOCDropdownChange: handleOCDropdownChange, currentChannel: currentChannel, currentChannelName: currentChannelName, isTranslateLoading: isTranslateLoading, isTranslated: isTranslated, isAgentFeedbackEnabled: isAgentFeedbackEnabled, webSDKSaved: !((_f = (_e = feedbackMessagesData.bot[languageSource]) === null || _e === void 0 ? void 0 : _e[currentHybridLanguage]) === null || _f === void 0 ? void 0 : _f.length) ||
                !((_h = (_g = feedbackMessagesData.agent[languageSource]) === null || _g === void 0 ? void 0 : _g[currentHybridLanguage]) === null || _h === void 0 ? void 0 : _h.length) ||
                (feedbackMessagesEdited &&
                    currentChannel.toString() === constants_1.DEFAULTS.CHANNEL_ID) }));
    };
    var handleTaskTransfer = react_1["default"].useCallback(function (taskId) {
        if (!taskId || !utils_2.canTransfer([constants_2.TRANSFER_TYPE.TASK]))
            return;
        if (taskBoxEdited) {
            BotActions_1.createAlert('Please save all the changes before transferring', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        activateConfirmationDialog({
            title: 'Do you want to publish this task?',
            message: 'This would publish this task to production.',
            positiveText: 'Publish',
            negativeText: 'Cancel',
            themed: true,
        }, function (success) { return __awaiter(void 0, void 0, void 0, function () {
            var headers, transferApiResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!success)
                            return [2 /*return*/];
                        headers = utils_2.getBusinessAuditHeaders(businessId, 'transfer_task', activePartners.map(function (partner) { return partner.name; }));
                        return [4 /*yield*/, actions_1.transferTasks([taskId], headers)];
                    case 1:
                        transferApiResponse = _a.sent();
                        if (!transferApiResponse) {
                            BotActions_1.createAlert('Publish failed! Try again', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return [2 /*return*/];
                        }
                        BotActions_1.createAlert('Publish successful!', null, MogamboConstants_1.AlertTypes.POSITIVE);
                        return [2 /*return*/];
                }
            });
        }); });
    }, [taskBoxEdited, activateConfirmationDialog, businessId, activePartners]);
    var handleAllTasksTransfer = react_1["default"].useCallback(function () {
        if (!utils_2.canTransfer([constants_2.TRANSFER_TYPE.TASK]))
            return;
        if (taskBoxEdited) {
            BotActions_1.createAlert('Please save all the changes before transferring', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        activateConfirmationDialog({
            title: "Do you want to publish all Menu Options of Business: " + viaName + "?",
            message: 'The tasks will be published to Production.',
            positiveText: 'Publish',
            negativeText: 'Cancel',
            themed: true,
        }, function (success) { return __awaiter(void 0, void 0, void 0, function () {
            var headers, IdsToTransfer, transferApiResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!success)
                            return [2 /*return*/];
                        headers = utils_2.getBusinessAuditHeaders(businessId, 'transfer_all_task', activePartners.map(function (partner) { return partner.name; }));
                        IdsToTransfer = [];
                        Object.keys(taskBoxData.business_tasks).forEach(function (key) {
                            var taskBoxIds = taskBoxData.business_tasks[key].map(function (task) { return task.id; });
                            IdsToTransfer = IdsToTransfer.concat(taskBoxIds);
                        });
                        return [4 /*yield*/, actions_1.transferTasks(IdsToTransfer, headers)];
                    case 1:
                        transferApiResponse = _a.sent();
                        if (!transferApiResponse) {
                            BotActions_1.createAlert('Publish failed! Try again', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return [2 /*return*/];
                        }
                        BotActions_1.createAlert('Publish successful!', null, MogamboConstants_1.AlertTypes.POSITIVE);
                        return [2 /*return*/];
                }
            });
        }); });
    }, [
        taskBoxEdited,
        activateConfirmationDialog,
        viaName,
        businessId,
        activePartners,
        taskBoxData.business_tasks,
    ]);
    return (react_1["default"].createElement(TabContainer_1["default"], { title: "Content Management", isSaveDisabled: utils_1.isProduction() ||
            !(taskBoxEdited || botBreakEdited || feedbackMessagesEdited), isLoaderActive: isLoaderActive, onSave: handleSave },
        react_1["default"].createElement("div", { className: "contentManagement" },
            react_1["default"].createElement("div", { className: "contentManagementHeader" },
                allLanguages.length > 0 && (react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select a Language", className: "languageSelect", options: allLanguages, optionKey: "name", label: "Language", value: getSelectedLanguage(languageCode), onChange: handleLanguageChange })),
                react_1["default"].createElement(button_1["default"], { className: "contentManagementHeaderTransfer", onClick: handleAllTasksTransfer, disabled: utils_1.isProduction() }, "Publish all Menu Options")),
            react_1["default"].createElement(tabs_1["default"], { value: currentTab, className: "contentManagementTabs" },
                react_1["default"].createElement(tabs_1["default"].Item, { value: constants_1.TABS.TASKBOX, prefixClassName: "tabItem", onClick: handleTabChange }, "Menu"),
                react_1["default"].createElement(tabs_1["default"].Item, { value: constants_1.TABS.BOT_BREAK, prefixClassName: "tabItem", onClick: handleTabChange }, "Bot Break Messages"),
                react_1["default"].createElement(tabs_1["default"].Item, { value: constants_1.TABS.AGENT_FEEDBACK, prefixClassName: "tabItem", onClick: handleTabChange }, "Feedback")),
            react_1["default"].createElement("div", { className: "contentManagementTabContent" },
                currentTab === constants_1.TABS.AGENT_FEEDBACK && renderFeedbackMessages(),
                currentTab === constants_1.TABS.TASKBOX
                    ? allTaskBoxData.body && (react_1["default"].createElement(TaskBox_1["default"], { taskBoxData: taskBoxData, handleChange: handleTaskBoxChange, languageCode: languageCode, addNewTask: addNewTask, sortTaskList: sortTaskList, toggleTransferModal: handleTaskTransfer, disabled: utils_1.isProduction() }))
                    : currentTab !== constants_1.TABS.AGENT_FEEDBACK && renderBotBreakMessages()))));
};
exports["default"] = confirmationDialog_1["default"]()(ContentManagement);
